import React from "react";
import ImageWithPlaceholder from "../../Common/ImageWithPlaceholder";
import MVMIcon from "../../Common/MVMIcon";
import { formatDistanceScaled } from "@/common/common";
const ProfileInfo = ({ user }) => {
    // @ts-ignore
    const isUser = window?.isUser == 1;
    const totalDistanceVal = formatDistanceScaled(+user.stats.totalDistances.actualDistanceTotalPostUserLogId + +user.stats.totalDistances.virtualDistanceTotalPreUserLogId);
    return (React.createElement("div", { className: 'profile-info' },
        React.createElement("div", { className: 'd-flex' },
            React.createElement("div", { className: 'me-1 w-40 d-flex flex-column' },
                React.createElement("div", { className: 'position-relative mb-auto' },
                    isUser ? (React.createElement("a", { href: '/default/modify-photo', rel: 'tooltip', title: 'Click to modify photo' },
                        React.createElement(ImageWithPlaceholder, { className: 'profile-info-avatar', src: "/" + user.image }))) : (React.createElement(ImageWithPlaceholder, { className: 'profile-info-avatar', src: "/" + user.image })),
                    React.createElement("img", { className: 'profile-info-country', src: "/public/images/flags/square/" +
                            user.countryCode +
                            ".png", alt: '' })),
                React.createElement("div", { className: 'profile-info-block' },
                    React.createElement("h3", { className: 'profile-info-header text-truncate' },
                        "Total Distance",
                        React.createElement("span", { className: 'd-flex', 
                            //@ts-ignore
                            rel: 'tooltip', title: 'The total distance travelled along all of your virtual mission pathways (Eg: Add 5km to 3 missions. 5km x 3 = 15km)' },
                            React.createElement(MVMIcon, { icon: 'question-circle' }))),
                    React.createElement("h4", { className: 'profile-info-number secondary-color weight-500' },
                        totalDistanceVal,
                        user.distanceUnit))),
            React.createElement("div", { className: 'flex-grow-1 d-flex flex-column justify-content-between w-60' },
                React.createElement("h2", { className: 'profile-info-name' },
                    user.firstName,
                    React.createElement("span", { className: 'weight-300' },
                        " ",
                        user.lastName)),
                React.createElement("div", { className: 'd-flex' },
                    React.createElement("div", { className: 'w-50 me-1' },
                        React.createElement("div", null,
                            React.createElement("h3", { className: 'profile-info-header secondary-color' }, "Missions"),
                            React.createElement("h4", { className: 'profile-info-number primary-color' }, user.stats.activeMissions)),
                        React.createElement("div", { className: 'profile-info-block' },
                            React.createElement("h3", { className: 'profile-info-header text-truncate' }, "This Month"),
                            React.createElement("h4", { className: 'profile-info-number secondary-color weight-500' }, user.stats.distanceMonth))),
                    React.createElement("div", { className: 'w-50' },
                        React.createElement("div", null,
                            React.createElement("h3", { className: 'profile-info-header secondary-color' }, "Completed"),
                            React.createElement("h4", { className: 'profile-info-number primary-color' }, user.stats.completedMissions)),
                        React.createElement("div", { className: 'profile-info-block' },
                            React.createElement("h3", { className: 'profile-info-header text-truncate' }, "This Year"),
                            React.createElement("h4", { className: 'profile-info-number secondary-color weight-500' }, user.stats.distanceYear)))))),
        React.createElement("div", { className: 'd-flex mt-4' })));
};
export default ProfileInfo;
